import React from 'react'

import { PAGE_MENU } from '../../constants';
import Title from '../title';

export default function Component() {
  return (
    <Title>
      {PAGE_MENU.CONTACT}
    </Title>
  );
}
